<template>
  <div class="container">
    <h3 class="title">Przepraszamy, wystąpił błąd</h3>
    <div class="btn-group">
        <a :href="`tel:${$phone}`" class="btn" :style="{ background: $color }">Telefon</a>
        <button type="button" class="btn" :style="{ background: $color }" @click="setHomePage">MENU</button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: "DataSentError",
  methods: {
    ...mapMutations(['setHomePage'])
  }
}
</script>

<style scoped lang="scss">
.text {
  margin-top: 16px;
  color: #454545;
  font-size: 14px;
  line-height: 25px;
  padding-right: 16px;
  span {
    margin-top: 8px;
    display: block;
  }
}
.result {
  display: flex;
}
.container {
  width: 400px;
}
.btn {
  margin: 0;
}
.btn-group {
  margin-top: 24px;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/components/assistance_steps/DataSentError.vue